import React, { useState } from 'react';

import {
  Row,
  Col,
  Form,
  InputGroup,
  Input,
  Button
} from 'reactstrap';

import axios from 'axios';

import Files from "react-butterfiles";

const MAX_SIZE_MB = 5;
const MAX_FILES_COUNT = 1;
const FORM_NAME = 'comment';

const filesTypeErrorMessages = (type, maxSizeMb, maxFilesCount) => {
  switch (type){
    case 'unsupportedFileType':
      return 'Formato del archivo no soportado'
    case 'maxSizeExceeded':
      return `El archivo excede el tamaño máximo de ${ maxSizeMb }mb`
    case 'Without':
      return 'No hemos encontado contratación para el archivo'
    case 'multipleMaxCountExceeded':
    return `No puedes cargar más de ${ maxFilesCount } archivos`
    default:
    return 'Error en el archivo'
  }
}

const CommentForm = props => {

  const {
    configuration: {
      defaultRequestParams = {},
      routes = {},
      formName = FORM_NAME,
      fileUpload: {
        enable: fileUploadEnable = true,
        contentTypes: fileUploadContentTypes = ['application/pdf'],
        maxSizeMb: fileUploadMaxSizeMb = MAX_SIZE_MB,
        maxFilesCount: fileUploadMaxFilesCount = MAX_FILES_COUNT
      } = {}
    } = {},
    callbacks: {
      pushComment: callbackOnPushComment
    }
  } = props;

  const [comment, setComment] = useState({
    body: '',
    files: []
  });

  const onChangeComment = (event, key) => {
    let value = event.target.value;

    setComment({
      ...comment,
      [key]: value
    });
  };

  const onUploadFiles = files => {
    const srcs = _.map(files, 'src.file')

    if(comment.files.length + srcs.length > fileUploadMaxFilesCount) {
      swalToastBootstrap.fire({
        icon: 'error',
        title: `No puedes cargar más de ${ fileUploadMaxFilesCount } archivos`
      });
      return;
    }

    setComment(prevState => {
      return {
        ...prevState,
        files: [ ... prevState.files, ...srcs]
      }
    })
  }

  // -------------------- START SUBMIT COMMENT --------------------
  const getCommentFormData = () => {
    let formData = new FormData();

    formData.append(`${ formName }[body]`, comment.body || '');

    if(fileUploadEnable) {
      _.each(comment.files, (file) => {
        formData.append(`${ formName }[files][]`, file || '');
      })
    }

    return formData;
  }

  const createService = async(endpoint, formData) => {
    let response = await axios({
      method: 'post',
      url: endpoint,
      data: formData,
      headers: {
        "X-CSRF-TOKEN": window.compliance.token
      }
    })

    return response;
  }

  const onSubmitComment = (event) => {
    event.preventDefault();

    const formData = getCommentFormData();

    let createPath = routes.createCommentPath({...defaultRequestParams, format: 'json'});

    createService(createPath, formData).then(response => {
      if(response.status == 201){
        swalToastBootstrap.fire({
          icon: 'success',
          title: 'Comentario creado correctamente'
        });

        if(_.isFunction(callbackOnPushComment)) {
          callbackOnPushComment(response.data);
        }

        setComment({
          body: '',
          files: []
        })
      }
    }).catch(error => {
      let objectErrors = error.response.data.errors

      _.each(objectErrors, (error, key) => {
        swalToastBootstrap.fire({
          icon: 'error',
          title: error
        });
      })
    })
  };
  // -------------------- END SUBMIT COMMENT --------------------

  const inputGroups = (browseFiles, getDropZoneProps) => {
    return (
      <>
        <InputGroup>
          <Button
            type='button'
            outline
            color='secondary'
            onClick={ browseFiles }
          >
            <i className="fas fa-paperclip fa-lg"></i>
          </Button>

          <Input
            type="text"
            placeholder="Escribe tu comentario"
            value={ comment?.body || '' }
            invalid={ _.has(comment.errors, 'body') }
            onChange={ event => onChangeComment(event, 'body') }
          />

          <Button
            type="submit"
            color='primary'
          >
            <i className="fas fa-paper-plane fa-lg"></i>
          </Button>
        </InputGroup>
      </>
    )
  }

  const fileListUpload = () => {
    if(comment.files.length > 0) {
      return (
        <Row>
          <Col md={12}>
            <CommentFileList
              files={ comment.files}
              callbacks={{
                onChangeComment: onChangeComment
              }}
            />
          </Col>
        </Row>
      )
    }
  }

  return (
    <Row>
      <Col md={12}>
        <Form onSubmit={ onSubmitComment }>
          <Files
            multiple={ false }
            maxSize={ `${ fileUploadMaxSizeMb }mb` }
            multipleMaxSize={ `${ fileUploadMaxSizeMb * fileUploadMaxFilesCount }mb`}
            multipleMaxCount={ fileUploadMaxFilesCount }
            accept={ fileUploadContentTypes }
            onError={ errors => {
              _.each(errors, error => {
                swalToastBootstrap.fire({
                  icon: 'error',
                  title: filesTypeErrorMessages(error.type, fileUploadMaxSizeMb, fileUploadMaxFilesCount)
                });
              })
            }}
            onSuccess={ response => onUploadFiles(response)}
          >
            { ( { browseFiles, getDropZoneProps } ) => {
              return (
                inputGroups(browseFiles, getDropZoneProps)
              )
            }}
          </Files>

          { fileListUpload() }
        </Form>
      </Col>
    </Row>
  );
};

const CommentFileList = props => {
  const {
    files,
    callbacks: {
      onChangeComment: callbackOnChangeComment
    }
  } = props;

  const onDeleteFile = (fileIndex) => {
    _.remove(files, (file, index) => { return index == fileIndex })

    callbackOnChangeComment(
      { target: { value: files } },
      'files'
    )
  }

  return(
    <Row className='mt-1'>
      <Col md={12}>
        { _.map(files, (file, index) => {
          return(
            <CommentFileListItem
              key={ `CommentFileListItem-${ _.uniqueId() }` }
              file={ file }
              index={ index }
              callbacks={{
                onDeleteFile: onDeleteFile
              }}
            />
          )
        })}
      </Col>
    </Row>
  )
}

const CommentFileListItem = props => {
  const {
    file,
    index,
    callbacks: {
      onDeleteFile: callbackOnDeleteFile
    }
  } = props;

  return (
    <div
      className="badge badge-pill badge-light py-1 px-2 d-inline-block mr-2 mb-1"
    >
      <i className="fas fa-paperclip mr-2"></i>
      { file.name }
      <button
        className="btn p-0 btn-link ml-2"
        alt="Delete"
        onClick={ event => callbackOnDeleteFile(index) }
      >
        <i className="fas fa-times text-danger"></i>
      </button>
    </div>
  );
}

export default CommentForm;


